import './App.css';
import FlashCardsHome from './Components/Create FlashCards/FlashCardsHome';
import Navbar from './Components/Navbar/Navbar';

function App() {
  return (
    <div>
      <Navbar />
      <FlashCardsHome />
    </div>
  );
}

export default App;
